export default "__VITE_ASSET__CrGB9AD5__"